import { render, staticRenderFns } from "./Doll.vue?vue&type=template&id=99dd2ace&"
import script from "./Doll.vue?vue&type=script&lang=js&"
export * from "./Doll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports